// @ts-nocheck
import React from "react";

interface ReviewButtonProps {
    [key: string]: any;
}

export default function ReviewButton(props: ReviewButtonProps) {
    return (
        <button
            {...props}
            className="flex items-center justify-center gap-2 px-3 py-2 rounded-md bg-[#0F172A] text-white h-10 w-[110px] hover:bg-gray-800 transition-colors"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 11.3333L3.33333 12.6666L6 9.99992M8.66667 3.99992H14M8.66667 7.99992H14M8.66667 11.9999H14M2.66667 3.33325H5.33333C5.70152 3.33325 6 3.63173 6 3.99992V6.66659C6 7.03478 5.70152 7.33325 5.33333 7.33325H2.66667C2.29848 7.33325 2 7.03478 2 6.66659V3.99992C2 3.63173 2.29848 3.33325 2.66667 3.33325Z" stroke="#F8FAFC" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Review</span>
        </button>
    );
}
